import { Injectable, inject } from "@angular/core";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";

@Injectable({
  providedIn: "root",
})
export class IconService {
  private domSanitizer = inject(DomSanitizer);
  private matIconRegistry = inject(MatIconRegistry);

  svgIcons = new Set();

  initCustomIcons(): void {
    this.addCustomIcon("build");
    this.addCustomIcon("error");
  }

  private addCustomIcon(name: string): void {
    this.matIconRegistry.addSvgIcon(
      name,
      this.domSanitizer.bypassSecurityTrustResourceUrl(
        `../assets/icons/${name}-24px.svg`
      )
    );

    this.svgIcons.add(name);
  }
}
